export {
    default as Icon,
    IIconProps,
} from './icon';
